// extracted by mini-css-extract-plugin
export default {"goldContainer":"style_goldContainer__CDFnX","goldText":"style_goldText__hFh9R"};